import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/fonts/font.scss";
import "./assets/style/style.scss";
import {
  useCallback,
  useContext,
  useEffect,
  useState,
  lazy,
  Suspense,
} from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  ACTIVATES,
  EULA_OTHER,
  FORGOT,
  LOGIN,
  PRIVACY_POLICYs,
  RESETPASSWORD,
  TERMS_AND_CONDITION,
  UNSUBSCRIBE_USER,
  VERFIY_EMAIL,
  WELCOME,
} from "./constants/pathname";

// components
const Login = lazy(() => import("./pages/login/login"));
const PrivateRoutes = lazy(() => import("./privateRoutes"));
const Activate = lazy(() => import("./pages/Activate/activate"));
const Forgot = lazy(() => import("./pages/forgot/forgot"));
const Newpassword = lazy(() => import("./pages/newpassword/newpassword"));
const VerfiyEmail = lazy(() => import("./pages/verfiyemail/verfiyemail"));
const TermsCondtion = lazy(() => import("./common/termscondtion"));
const PrivacyPolicys = lazy(() => import("./common/privacypolicy"));
const Welcome = lazy(() => import("./components/welcome/welcome"));

import "rsuite/dist/rsuite.min.css";
import "react-image-gallery/styles/css/image-gallery.css";
import BookingRestrictionModal from "./components/common/BookingRestrictionModal";

import { requestForToken, onMessageListener, messaging } from "./firebase";
import { Toaster } from "react-hot-toast";
import Loader from "./common/loader";

import { getToken, onMessage } from "firebase/messaging";
import { updateFCM } from "./api/actions/auth";
import Pushnotification from "./common/pushnotification";
import { NotificationContext, UpdateContext } from "./Context/Store";
import { LoadScript } from "@react-google-maps/api";
import { Helmet } from "react-helmet-async";
import { checkTheme, checkThemePcw } from "./utils/utils";
import language from "./assets/images/common/language.svg";
import { Button, Modal } from "react-bootstrap";
import Unsubscribed from "./components/unsubscribed/unsubscribed";
import EulaOther from "./components/profilesettings/EulaOther";

const libraries = ["places"];

function isSafariOnIphone() {
  const userAgent = navigator.userAgent;
  return (
    /iPad|iPhone|iPod/.test(userAgent) &&
    /Safari/.test(userAgent) &&
    !/Chrome|CriOS/.test(userAgent)
  );
}

const _notificationStatus = {
  granted: "granted",
  denied: "denied",
  default: "default",
  none: "none",
};

function App() {
  const [metObj, setOMetaobj] = useState({
    title: "",
    ogimage: "",
    descrption: "",
  });
  const [favicon, setFavicon] = useState("");
  const [hostes, setHostes] = useState("");

  const [notificationPermissionStatus, setNotificationPermissionStatus] =
    useState(() => {
      // console.log("Notification" in window,"NOTI")
      if ("Notification" in window) {
        return Notification.permission;
      } else {
        return _notificationStatus.none;
      }
    });
  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    setIsSafari(isSafariOnIphone());
  }, []);

  useEffect(() => {
    // Set theme based on origin
    const htmlElement = document.documentElement;
    if (checkTheme()) {
      htmlElement.setAttribute("theme", "platinum-club-net");
    } else {
      htmlElement.setAttribute("theme", "");
    }

    // htmlElement.setAttribute('theme', 'platinum-club-net');
  }, []);

  useEffect(() => {
    // Detect the current domain
    const hostname = window.location.origin;
    setHostes(hostname);
    console.log(hostname);
    // Set favicon based on the domain
    const favicon = document.querySelector("link[rel='icon']");
    if (checkTheme()) {
      favicon.href = "/favicon-pcn.ico";
      setFavicon(`${hostname}/favicon-pcn.ico`);
      setOMetaobj({
        ogimage: `${hostname}/pcn-og.png`,
        descrption:
          "Curate bespoke experiential events and offer access to network of platinum clubs worldwide with PlatinumClubNet in association with Club Leaders Forum",
        title: "PlatinumClubNet",
      });
    } else if (checkThemePcw()) {
      favicon.href = "/favicon-pcw.ico";
      setFavicon(`${hostname}/favicon-pcw.ico`);

      setOMetaobj({
        ogimage: `${hostname}/pcw-og.png`,
        descrption:
          "Manage Your Club's Reciprocal Network and Member Requests, Seamlessly. A Reciprocity Management System for existing private club networks, creating a galaxy, agnostic to club verticals, complemented by a Global Private Club Citizenship.",
        title: "PrivateClubWorld",
      });
    }
  }, []);
  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  const [notification, setNotification] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isSafari) {
      setShowModal(true);
    } else {
      console.log(isSafari, "ISSAFARI");
    }
  }, []);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      // 1. Register the SW
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log(
            "Service Worker registered with scope:",
            registration.scope,
          );
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });

      // 2. Listen for messages from the SW
      // navigator.serviceWorker.addEventListener("message", (event) => {
      //   if (event.data && event.data.type === "NEW_NOTIFICATION") {
      //     const { title, body, icon } = event.data;
      //     console.log("sw-firebase1", event.data);
      //     setNotification({ title, body, icon });
      //   }
      // });
    }
  }, []);

  useEffect(() => {
    requestForToken();
  }, []);

  onMessage(messaging, (payload) => {
    console.log("Load-Message:", payload);
    const { title, body } = payload?.notification;
    setNotification({ title, body });
  });

  const handleEnableNotifications = useCallback(() => {
    if (notificationPermissionStatus === _notificationStatus.none) {
      return;
    }

    if (notificationPermissionStatus === _notificationStatus.granted) {
      return;
    }
    Notification.requestPermission().then((permission) => {
      setNotificationPermissionStatus(permission);
    });
  }, [notificationPermissionStatus]);

  let notificationToken = null;

  const onResponse = (error, token) => {
    if (error) {
      console.log(error);
    } else {
      notificationToken = token;
      console.log("FCM Token generated successfully :", token);
      const logged = localStorage.getItem("is_logged");
      if (logged) {
        localStorage.setItem("login_FCM", notificationToken);
        updateFCM({ fcm_token: token })((response) => {
          if (response?.status) {
            console.log(response, "res");
          }
        });
      }
    }
  };

  const requestForToken = useCallback(async () => {
    try {
      if (notificationPermissionStatus === _notificationStatus.granted) {
        const token = await getToken(messaging, {
          vapidKey:
            "BBuCxrEjy40WreviDCst8DgBgaB9DutVMMYf_XAIZ5Widy06EsK8OQ6oj9DNYDlL-NtZ2_ti-M4i8Tv4cYIVqwA",
        });
        if (token) {
          onResponse(null, token);
        } else {
          console.log(
            "No registration token available. Request permission to generate one.",
          );
        }
      }
    } catch (error) {
      console.error("Error while fetching FCM token:", error);
    }
  }, [notificationPermissionStatus]);

  const handleCloseNotification = () => {
    setNotification(null);
  };
  useEffect(() => {
    document.body.style.top = "0px"; // Reset top position
    document.body.style.position = "static"; // Reset position
    document.body.style.minHeight = "auto";
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        { pageLanguage: "en" },
        "google_translate_element",
      );
    };
    setTimeout(() => {
      const selectElement = document.querySelector(".goog-te-combo");
      if (selectElement) {
        selectElement.addEventListener("change", () => {
          let elem = document.getElementById("google_translate_element");
          elem.style.marginRight = "-270px";
          document.body.style.top = "0px"; // Reset top position
          document.body.style.position = "static"; // Reset position
          document.body.style.minHeight = "auto";
        });
      }
    }, 4000);
  }, []);
  const handleTranslatorShow = () => {
    let elem = document.getElementById("google_translate_element");
    console.log(elem.style.marginRight);
    if (elem.style.marginRight == "0px") {
      elem.style.marginRight = "-270px";
      elem.style.visibility = "visible";
    } else {
      elem.style.marginRight = "0px";
      elem.style.visibility = "visible";
    }
  };

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_API_KEY}
      libraries={libraries}
    >
      <button
        onClick={() => handleTranslatorShow()}
        style={{
          position: "fixed",
          top: "150px",
          right: "0px",
          padding: "5px 5px",
          backgroundColor: "var(--sandy-brown)",
          color: "#fff",
          border: "none",
          borderRadius: "0px",
          cursor: "pointer",
          zIndex: 1000,
        }}
      >
        <div>
          <img src={language} alt="lang" style={{ height: "25px" }} />
        </div>
        <div className="translate-text">Translate</div>
      </button>

      {/* Notification permission button - only shows if permission not granted */}

      {notificationPermissionStatus === _notificationStatus.default ||
      notificationPermissionStatus === _notificationStatus.denied ? (
        <button
          onClick={handleEnableNotifications}
          style={{
            position: "fixed",
            bottom: "10px",
            right: "0px",
            padding: "5px 10px",
            backgroundColor: "var(--sandy-brown)",
            color: "#fff",
            border: "none",
            borderRadius: "0px",
            cursor: "pointer",
            zIndex: 1000,
          }}
        >
          Enable Notifications
        </button>
      ) : null}

      {/* Translator Dropdown (Hidden Initially) */}

      <div className="private-club-world">
        {metObj?.ogimage && (
          <Helmet>
            <title>{metObj.title}</title>
            <meta name="description" content={metObj.descrption} />
            <meta property="og:title" ccontent={metObj.title} />
            <meta property="og:url" content={hostes} />
            <meta property="og:description" content={metObj.descrption} />
            <meta property="og:image" content={metObj.ogimage} />
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={hostes} />
            <meta name="twitter:title" content={metObj.title} />
            <meta property="twitter:image" content={metObj.ogimage} />
            <meta name="twitter:description" content={metObj.descrption} />
          </Helmet>
        )}
        <BrowserRouter>
          <Toaster position="top-center" toastOptions={{ duration: 2000 }} />
          <BookingRestrictionModal />
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path={LOGIN} element={<Login />} />
              <Route path={ACTIVATES} element={<Activate />} />
              <Route path={FORGOT} element={<Forgot />} />
              <Route path={VERFIY_EMAIL} element={<VerfiyEmail />} />
              <Route path={RESETPASSWORD} element={<Newpassword />} />
              <Route path={TERMS_AND_CONDITION} element={<TermsCondtion />} />
              <Route path={PRIVACY_POLICYs} element={<PrivacyPolicys />} />
              <Route path={WELCOME} element={<Welcome />} />
              <Route path="/*" element={<PrivateRoutes />} />
              <Route path={UNSUBSCRIBE_USER} element={<Unsubscribed />} />
              <Route path={EULA_OTHER} element={<EulaOther />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        {notification && (
          <Pushnotification
            title={notification?.title}
            body={notification?.body}
            onClose={handleCloseNotification}
          />
        )}

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Quick Add</Modal.Title>
          </Modal.Header>

          <Modal.Body className="text-center space-y-2">
            <p>For a better experience, add this site to your home screen.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => setShowModal(false)}
              style={{
                border: "1px solid var(--sandy-brown)",
                color: "var(--sandy-brown)",
                backgroundColor: "var(--black)",
              }}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </LoadScript>
  );
}

export default App;
